<mat-checkbox [formControl]="formControl">
    {{ config.label ? config.label : config.name }}
</mat-checkbox>